import { render, staticRenderFns } from "./10-member-profile-extras.vue?vue&type=template&id=31c1a6d8&scoped=true"
import script from "./10-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./10-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./10-member-profile-extras.vue?vue&type=style&index=0&id=31c1a6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1a6d8",
  null
  
)

export default component.exports